module.exports = __webpack_public_path__ + "static/img/7.5b470e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/sp/7.png
// module id = 6Pk0
// module chunks = 0